<template>
  <div>
    <b-tabs
      pills
      fill
    >
      <b-tab>
        <template #title>
          <feather-icon icon="InfoIcon" />
          Ürün Bilgileri
        </template>
        <b-card>
          <product-info />
        </b-card>
        <vehicle-types />
        <products-image-card />
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="InfoIcon" />
          Teknik Özellikler
        </template>
        <product-items-form />
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="InfoIcon" />
          Ürün Galerisi
        </template>
        <products-photo-gallery />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BCard, BTab, BTabs,
} from 'bootstrap-vue'
import ProductInfo from '@/views/Admin/Products/Components/ProductInfo.vue'
import ProductsImageCard from '@/views/Admin/Products/Elements/ImageCard.vue'
import ProductItemsForm from '@/views/Admin/Products/Components/ProductItems.vue'
import ProductsPhotoGallery from '@/views/Admin/Products/Elements/PhotoGalleryCard.vue'
import VehicleTypes from '@/views/Admin/Products/Elements/VehicleTypes.vue'

export default {
  name: 'ProductsItemForm',
  components: {
    VehicleTypes,
    ProductsPhotoGallery,
    ProductItemsForm,
    ProductsImageCard,
    ProductInfo,
    BCard,
    BTab,
    BTabs,
  },
  computed: {
    itemData() {
      return this.$store.getters['products/dataItem']
    },
  },
}
</script>
